import { render, staticRenderFns } from "./ReviewData.vue?vue&type=template&id=017b6d00&scoped=true&"
import script from "./ReviewData.vue?vue&type=script&lang=js&"
export * from "./ReviewData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017b6d00",
  null
  
)

export default component.exports